import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { useData } from '../data/DataProvider';
import { date, money, invoiceTotal } from '../shared/formatters';
import { useToast } from '../shared/components/ToastProvider';

// Landing page for the Stripe Checkout success/cancel redirects
// (pass 6 §6E). The SPA's portal session survives the round-trip, so a
// "back to your portal" link resumes where they left off.
export default function PaymentStatus({ paid }) {
  const { invoiceId } = useParams();
  const { data, refresh } = useData();
  const { notify } = useToast();
  const invoice = data.invoices.find((item) => item.id === invoiceId);
  const slug = data.tenant.slug || '';

  // On a paid return, the checkout webhook has already marked the invoice
  // paid server-side — pull fresh data so this screen is truthful.
  const [refreshed, setRefreshed] = React.useState(false);
  React.useEffect(() => {
    if (paid && !refreshed) {
      setRefreshed(true);
      refresh().catch(() => {});
      notify('Payment received — thank you!');
    }
  }, [paid]);

  return (
    <div className="portal-frame">
      <div className="portal-main">
        <section className="portal-card">
          <span className="eyebrow">{paid ? 'Payment received' : 'Payment cancelled'}</span>
          <h1>{paid ? 'Thank you!' : 'No charge made'}</h1>
          <p className="field-hint">
            {paid
              ? invoice
                ? `${invoice.number} · ${money(invoiceTotal(invoice))} was paid on ${date(new Date().toISOString().slice(0, 10))}. A receipt is on its way.`
                : 'Your payment went through — the invoice is now marked paid.'
              : 'The checkout was cancelled — nothing was charged. You can try again from the invoice, or pay by bank transfer.'}
          </p>
          <div className="invoice-actions">
            {invoice ? <Link className="primary-button" to={`/portal/${slug}/invoices/${invoice.id}`}>Back to the invoice</Link> : null}
            <Link className="secondary-button" to={`/portal/${slug}`}>Back to your portal</Link>
          </div>
        </section>
      </div>
    </div>
  );
}
